const BuyIcon = ({ ...props }) => {
  const { color = 'var(--pcm-body-color)' } = props;
  return (
    <svg width='18' height='17' viewBox='0 0 18 17' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M3.698 3H14.9671C15.7675 3 16.4167 3.73292 16.4167 4.63711V5.63658H2.24837V4.63711C2.24837 3.73292 2.89862 3 3.698 3ZM3.69768 14.3536C2.8973 14.3536 2.24805 13.6207 2.24805 12.7165H2.24838V7.1041H16.4167V12.7165C16.4167 13.6207 15.7665 14.3536 14.9671 14.3536H3.69768Z'
        fill={color}
      />
    </svg>
  );
};

export default BuyIcon;
